import { render } from "./productEditSizePriceDialog.vue?vue&type=template&id=009965b2"
import script from "./productEditSizePriceDialog.vue?vue&type=script&lang=js"
export * from "./productEditSizePriceDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__